'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { useSentencaArbitral } from '../../hooks/useSentencaArbitral';
import type { DocumentoEncerramentoContainerProps } from '../../types/encerramento.types';
import { rotaProcessoPorOrigem } from '../../utils/rotaProcessoPorOrigem';
import { SentencaArbitralView } from './sentenca-arbitral/SentencaArbitralView';
export function SentencaArbitralContainer(t0) {
  const $ = _c(16);
  const {
    processoId,
    origem
  } = t0;
  const router = useRouter();
  const {
    sentenca,
    isLoading,
    error,
    semPermissao,
    naoPublicada,
    recarregar,
    documentoRef,
    isDownloadingPdf,
    baixarPdf,
    imprimir
  } = useSentencaArbitral(processoId, origem);
  let t1;
  if ($[0] !== origem || $[1] !== processoId || $[2] !== router) {
    t1 = () => {
      router.push(rotaProcessoPorOrigem(origem, processoId));
    };
    $[0] = origem;
    $[1] = processoId;
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleVoltar = t1;
  let t2;
  if ($[4] !== baixarPdf || $[5] !== documentoRef || $[6] !== error || $[7] !== handleVoltar || $[8] !== imprimir || $[9] !== isDownloadingPdf || $[10] !== isLoading || $[11] !== naoPublicada || $[12] !== recarregar || $[13] !== semPermissao || $[14] !== sentenca) {
    t2 = <SentencaArbitralView documentoRef={documentoRef} error={error} isDownloadingPdf={isDownloadingPdf} isLoading={isLoading} naoPublicada={naoPublicada} onBaixarPdf={baixarPdf} onImprimir={imprimir} onTentarNovamente={recarregar} onVoltar={handleVoltar} semPermissao={semPermissao} sentenca={sentenca} />;
    $[4] = baixarPdf;
    $[5] = documentoRef;
    $[6] = error;
    $[7] = handleVoltar;
    $[8] = imprimir;
    $[9] = isDownloadingPdf;
    $[10] = isLoading;
    $[11] = naoPublicada;
    $[12] = recarregar;
    $[13] = semPermissao;
    $[14] = sentenca;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}